export default function ProjsProtocolText(){
  return(
    <div>
      Protocol Text coming soon! 
    </div>
  );
}